import { uint8ToArrayBuffer } from './pdfFill.util'

const base64ToUint8Array = (base64: string): Uint8Array => {
  const clean = base64.includes(',') ? base64.split(',')[1] : base64

  const binary = atob(clean)
  const len = binary.length
  const bytes = new Uint8Array(len)

  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i)
  }

  return bytes
}

export const pdfBase64ToObjectUrl = (base64: string): string => {
  const bytes = base64ToUint8Array(base64)
  const blob = new Blob([uint8ToArrayBuffer(bytes)], { type: 'application/pdf' })
  return URL.createObjectURL(blob)
}

export type PdfRect = {
  x: number
  y: number
  width: number
  height: number
}

export type SignatureOverlay = {
  elementId: string
  pageIndex: number
  rect: PdfRect
  label?: string
}

const getPropValue = (props: any[] | undefined, key: string) => props?.find((p) => p.key === key)?.value

export const buildSignatureFieldsFromFormDef = (formDef: any): SignatureOverlay[] => {
  const elements = formDef?.pages?.flatMap((p: any) => p.sections ?? []).flatMap((s: any) => s.elements ?? []) ?? []

  return elements
    .filter((e: any) => e?.componentInterface === 'Signature')
    .flatMap((e: any) => {
      const rects = getPropValue(e.properties, 'rects') as
        | Array<{
            rect: PdfRect
            pageIndex: number
          }>
        | undefined

      if (!rects?.length) return []

      return rects
        .filter((r) => r?.rect && typeof r.pageIndex === 'number')
        .map((r) => ({
          elementId: e.label,
          pageIndex: r.pageIndex,
          rect: r.rect,
          label: e.label,
        }))
    })
}
